export default [
    {
        path: '/admin',
        component: () => import('./admin.vue'),
        children:[
            {
                path: '/',
                redirect: 'settings'
            },
            {
                path: 'settings',
                component: () => import('./settings/settings.vue'),
                children:[

                    {
                        path: '/',
                        redirect: 'main'
                    },
                    {
                        path: 'main',
                        component: () => import('./settings/main/main.vue'),
                    },
                    {
                        path: 'agreements',
                        component: () => import('./settings/agreements/agreements.vue'),
                    },
                    {
                        path: 'payments',
                        component: () => import('./settings/payments/payments.vue'),
                    },
                    {
                        path: 'payments-default',
                        component: () => import('./settings/payments-default/payments-default.vue'),
                    },
                    {
                        path: 'payments-system',
                        component: () => import('./settings/payments-system/payments-system.vue'),
                    },
                    {
                        path: 'newsletters',
                        component: () => import('./settings/newsletters/newsletters.vue'),
                    },
                    {
                        path: 'stylization',
                        component: () => import('./settings/stylization/stylization.vue'),
                    },
                    {
                        path: 'customer-fields',
                        component: () => import('./settings/customer-fields/customer-fields.vue'),
                    },
                    {
                        path: 'agreement-fields',
                        component: () => import('./settings/agreement-fields/agreement-fields.vue'),
                    },
                    {
                        path: 'events',
                        component: () => import('./settings/events/events.vue'),
                    },
                    {
                        path: 'service-fees',
                        component: () => import('./settings/service-fees/service-fees.vue'),
                    },
                    {
                        path: 'ip-telephony',
                        component: () => import('./settings/ip-telephony/ip-telephony.vue'),
                    },
                ]
            },
            {
                path: 'reports',
                component: () => import('./reports/reports.vue'),
            },
            {
                path: 'services',
                component: () => import('./services/services.vue'),
            },
            {
                path: 'directories',
                component: () => import('./directories/directories.vue'),
            },
            {
                path: 'widgets',
                component: () => import('./widgets/widgets.vue'),
            },
        ]
    }
]